import AppVersion from "@/enum/AppVersion";
import ShopType from "@/enum/ShopType";

/**
 * 续费提示图片
 */
const renewalTipImageSrcMapping = {
    [ShopType.TAOBAO]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01HVDPSH2DwkLZskd3h_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01HVDPSH2DwkLZskd3h_!!54458674.png",
    },
    [ShopType.KWAI]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01KFiIYB2DwkLd6ARYc_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01KFiIYB2DwkLd6ARYc_!!54458674.png",
    },
    [ShopType.KWAI_DROPSHIP]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i3/54458674/O1CN01DW4REs2DwkLd68ELu_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i1/54458674/O1CN015LYdBa2DwkLbvGTuA_!!54458674.png",
    },
    [ShopType.DOUDIAN_SUPPLIER]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN018P4mec2DwkUGgPXd5_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01EM78MV2DwkU8nPxF2_!!54458674.png",
    },
    [ShopType.DOUDIAN_IOP]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01FMbEIn2DwkLbvHtEP_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i1/54458674/O1CN01j3dHdD2DwkLTRHwSP_!!54458674.png",
    },
    [ShopType.DOUDIAN]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i1/54458674/O1CN0112ppBG2DwkLbvFoKL_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01oLI6qr2DwkLgoqZhB_!!54458674.png",
    },
    [ShopType.PINDUODUO]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01uqzPOE2DwkLd69VIq_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i1/54458674/O1CN01FwowYV2DwkLhhNCOD_!!54458674.png",
    },
    [ShopType.ALIBABA]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01C90OWa2DwkLTRKl75_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i3/54458674/O1CN01VhdQgW2DwkLc3Dr1u_!!54458674.png",
    },
    [ShopType.JD]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01lVPRqp2DwkTdR9veq_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01sngdjF2DwkTbhkeGs_!!54458674.png",
    },
    [ShopType.JD_PURCHASE]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01lVPRqp2DwkTdR9veq_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01sngdjF2DwkTbhkeGs_!!54458674.png",
    },

    [ShopType.CHANNEL_SHOP]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01eOytfT2DwkLZIDNMj_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01eOytfT2DwkLZIDNMj_!!54458674.png",
    },

    [ShopType.CHANNEL_SHOP_DROPSHIP]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01eOytfT2DwkLZIDNMj_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01eOytfT2DwkLZIDNMj_!!54458674.png",
    },

    [ShopType.CHANNEL_SHOP_SUPPLIER]: {
        [AppVersion.BASE]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01eOytfT2DwkLZIDNMj_!!54458674.png",
        [AppVersion.PREMIUM]: "https://img.alicdn.com/imgextra/i4/54458674/O1CN01eOytfT2DwkLZIDNMj_!!54458674.png",
    },
};

export default renewalTipImageSrcMapping;
